import {
  InstrumentAction,
  InstrumentEvent,
  InstrumentStatus,
  InstrumentTagType,
  InstrumentUploaderType,
} from '@finverity/graphql';
import { FinButtonAppearance } from '@finverity/ui-kit';

import { InstrumentApprovalConfigs, InstrumentApprovalRejectedSubscriptionEvents } from '../../../types';
import { InstrumentRejectedDataGridColId } from '../../instrument-rejected-container/constants';

export enum FunderApprovalRejectedFilterIdentifier {
  FunderApprovalRejected = 'FUNDER_APPROVAL_REJECTED',
  NotFundable = 'NOT_FUNDABLE',
}

const FUNDER_INSTRUMENT_APPROVAL_REJECTED_CONFIGS: InstrumentApprovalConfigs = {
  companyType: InstrumentUploaderType.DealManagerFunder,
  pageTitle: 'Funder Approval (Rejected)',
  actionsDefs: [
    {
      disabled: true,
      buttonText: 'Undo Rejection',
      buttonSvgIconName: 'fvIconInstrumentApprovalUndoRejection',
      buttonAppearance: FinButtonAppearance.Primary,
      actionType: InstrumentAction.FunderApprovalUndoRejection,
    },
  ],
  filtersDefs: [
    {
      identifier: FunderApprovalRejectedFilterIdentifier.FunderApprovalRejected,
      label: 'Funder Approval (Rejected)',
      params: {
        eventsType: [InstrumentEvent.FunderApprovalCheckerRejected, InstrumentEvent.FunderApprovalMakerRejected],
        statuses: [InstrumentStatus.FunderApprovalRejected],
        tags: {
          notIncludes: [
            InstrumentTagType.Deleted,
            InstrumentTagType.NotFundable,
            InstrumentTagType.NoEligibleFundingWindow,
          ],
        },
      },
      count: 0,
      hiddenColumns: [],
    },
    {
      identifier: FunderApprovalRejectedFilterIdentifier.NotFundable,
      label: 'Not Fundable',
      params: {
        eventsType: [InstrumentEvent.FunderApprovalCheckerRejected, InstrumentEvent.FunderApprovalMakerRejected],
        statuses: [InstrumentStatus.FunderApprovalRejected],
        tags: {
          notIncludes: [InstrumentTagType.Deleted],
          includes: [InstrumentTagType.NotFundable, InstrumentTagType.NoEligibleFundingWindow],
        },
      },
      count: 0,
      hiddenColumns: [
        InstrumentRejectedDataGridColId.DisbursementDate,
        InstrumentRejectedDataGridColId.Tenor,
        InstrumentRejectedDataGridColId.RepaymentDate,
        InstrumentRejectedDataGridColId.AdvanceRate,
        InstrumentRejectedDataGridColId.PrincipalAmount,
        InstrumentRejectedDataGridColId.DisbursementAmount,
        InstrumentRejectedDataGridColId.RepaymentAmount,
        InstrumentRejectedDataGridColId.NetUnfinancedBalance,
        InstrumentRejectedDataGridColId.SellerFeesInAdvance,
        InstrumentRejectedDataGridColId.PayerFeesInAdvance,
        InstrumentRejectedDataGridColId.SellerFeesInArrears,
        InstrumentRejectedDataGridColId.PayerFeesInArrears,
        InstrumentRejectedDataGridColId.TotalSellerFees,
        InstrumentRejectedDataGridColId.TotalPayerFees,
        InstrumentRejectedDataGridColId.TotalFees,
      ],
    },
  ],
  subscriptionEvents: <InstrumentApprovalRejectedSubscriptionEvents>{
    undoRejected: [InstrumentEvent.FunderApprovalMakerPending],
    updated: [InstrumentEvent.InstrumentEdited],
    removed: [InstrumentEvent.InstrumentDeleted],
  },
  viewUrl: 'funder-approval-rejected/view',
  editUrl: 'funder-approval-rejected/edit',
};

export function getFunderOrSellerInstrumentApprovalRejectedConfigs(
  instrumentUploaderType: InstrumentUploaderType.DealManagerFunder | InstrumentUploaderType.Seller
): InstrumentApprovalConfigs {
  return {
    ...FUNDER_INSTRUMENT_APPROVAL_REJECTED_CONFIGS,
    companyType: instrumentUploaderType,
  };
}
